import React from 'react';
import { NavLink } from 'react-router-dom';
import { motion } from 'framer-motion';

const linkClasses = "text-lp-paper/60 transition-colors hover:text-lp-paper";
const headClasses = "mb-4 font-ticket text-[10px] uppercase tracking-[0.18em] text-lp-paper/60";

const Footer = () => {
    return (
        <footer className="lp-root overflow-hidden bg-lp-ink px-5 pt-16 text-lp-paper sm:px-8">
            <div className="mx-auto grid max-w-[1400px] gap-10 border-t border-white/10 pt-12 sm:grid-cols-2 lg:grid-cols-12">
                <div className="lg:col-span-4">
                    <p className="max-w-sm text-2xl font-medium leading-snug tracking-[-0.03em]">
                        De eenvoudigste manier om je gasten online te laten <em className="font-editorial font-normal italic text-lp-blue">bestellen.</em>
                    </p>
                </div>
                <div className="flex flex-col gap-2.5 lg:col-span-2">
                    <p className={headClasses}>Ontdek</p>
                    <a href="/#menu" className={linkClasses}>Het menu</a>
                    <a href="/#demo" className={linkClasses}>Live demo</a>
                    <a href="/#prijzen" className={linkClasses}>Prijzen</a>
                    <a href="/#faq" className={linkClasses}>FAQ</a>
                    <NavLink to="/registreren" className={linkClasses}>Account aanmaken</NavLink>
                </div>
                <div className="flex flex-col gap-2.5 lg:col-span-3">
                    <p className={headClasses}>Voor je zaak</p>
                    <NavLink to="/online-bestellen-restaurant" className={linkClasses}>Online bestellen voor restaurants</NavLink>
                    <NavLink to="/online-bestellen-traiteur" className={linkClasses}>Online bestellen voor traiteurs</NavLink>
                    <NavLink to="/kerstmenu-online-bestellen" className={linkClasses}>Kerstmenu online laten bestellen</NavLink>
                </div>
                <div className="flex flex-col gap-2.5 lg:col-span-3">
                    <p className={headClasses}>Contact</p>
                    <a href="mailto:info@resto-online.be" className={linkClasses}>info@resto-online.be</a>
                    <a href="https://wa.me/32468229087" target="_blank" rel="noopener noreferrer" className={linkClasses}>WhatsApp</a>
                    <NavLink to="/algemene-voorwaarden" className={linkClasses}>Algemene voorwaarden</NavLink>
                    <NavLink to="/privacy" className={linkClasses}>Privacybeleid</NavLink>
                </div>
            </div>

            {/* reuzewoordmerk */}
            <motion.p
                aria-hidden
                initial={{ y: "40%" }}
                whileInView={{ y: "0%" }}
                viewport={{ once: true }}
                transition={{ duration: 1.4, ease: [0.22, 1, 0.36, 1] }}
                className="mx-auto mt-16 max-w-[1400px] select-none whitespace-nowrap text-center text-[15.5vw] font-semibold leading-[0.78] tracking-[-0.06em] text-lp-paper/[0.92] min-[1400px]:text-[216px]"
            >
                resto<span className="font-editorial font-normal italic text-lp-blue">-</span>online
            </motion.p>

            <div className="mx-auto flex max-w-[1400px] flex-col gap-2 border-t border-white/10 py-6 font-ticket text-[10px] uppercase tracking-[0.16em] text-lp-paper/60 sm:flex-row sm:justify-between">
                <p>&copy; {new Date().getFullYear()} Resto-Online. Alle rechten voorbehouden.</p>
                <p>Gemaakt door <a href="https://www.tuurdaneels.be" target="_blank" rel="noopener noreferrer" className="hover:underline">Tuur Daneels</a></p>
            </div>
        </footer>
    );
};

export default Footer;
